import React from "react"
import Footer from "./footer"
import Header from "./Header"
export default function App(){
    return(
        <React.Fragment>
            <Header/>
            <Footer/>
        </React.Fragment>
    )
}